import axios from "axios";

// Get the current hostname
const hostname = window.location.hostname;

// Set API URL based on environment
// const API_URL = hostname === 'localhost' || hostname === '127.0.0.1'
//   ? "http://localhost:5000/api"
//   : "http://192.168.213.105:5000/api";

// Set API URL based on the current hostname (e.g., 10.x.x.x or localhost).
// This supports local network access where frontend and backend are on the same VM or LAN.
// const API_URL = `https://${window.location.hostname}:5000/api`;

// Determine API URL based on environment
let API_URL;

if (process.env.NODE_ENV === "development") {
  // Local development (npm start)
  API_URL = `https://${window.location.hostname}:5000/api`;
} else {
  // Production build served under /portal
  API_URL = `/api`;
}

const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true
});

// Add a request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (!error.response) {
      console.error("Network error:", error.message);
      return Promise.reject(new Error("Network error. Please check your connection."));
    }

    if (error.response.status === 401) {
      const isLoginRequest = error.config?.url?.includes('/login');
      const backendMsg = error.response.data?.error || "Session expired. Please login again.";
      if (!isLoginRequest) {
        localStorage.removeItem("token");
        localStorage.removeItem("role");
        const basePath = window.location.pathname.startsWith("/portal") ? "/portal" : "";
        const loginPath = `${basePath}/`;
        if (window.location.pathname !== loginPath && window.location.pathname !== basePath) {
          window.location.href = loginPath;
        }
      }
      return Promise.reject(new Error(backendMsg));
    }

    // 403 e.g. "This portal is only for ScooterLab staff" – show backend message, no redirect on login
    if (error.response.status === 403) {
      const msg = error.response.data?.error || "Access denied.";
      return Promise.reject(new Error(msg));
    }

    const errorMessage = error.response.data?.error || "An error occurred";
    console.error("API error:", errorMessage);
    return Promise.reject({ error: errorMessage });
  }
);

export default api;
